import { Route, Switch } from "react-router-dom";
import Landing from "./components/Pages/Landing";
import "./css/app.scss";

function App() {
  return (
    <div className="app">
      <Switch>
        <Route exact path="/">
          <Landing />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
